/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumntarget3Inputs */

const en_sharereviewcolumntarget3 = /** @type {(inputs: Sharereviewcolumntarget3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page`)
};

const de_sharereviewcolumntarget3 = /** @type {(inputs: Sharereviewcolumntarget3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite`)
};

/**
* | output |
* | --- |
* | "Page" |
*
* @param {Sharereviewcolumntarget3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumntarget3 = /** @type {((inputs?: Sharereviewcolumntarget3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumntarget3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumntarget3(inputs)
	return de_sharereviewcolumntarget3(inputs)
});
export { sharereviewcolumntarget3 as "shareReviewColumnTarget" }